import { Checkbox, EmptyState, Icon, Icons, Spinner } from 'construct-ui';
import moment from 'moment';
import NewModelDisplayPieChartComponent from '../../components/charts/pie/new-model-display-pie-chart.component';
import NewModelDisplayClusteredBarChartComponent from '../../components/charts/xy/new-model-display-clustered-bar-chart.component';
import NewModelDisplayStackedBarChartComponent from '../../components/charts/xy/new-model-display-stacked-bar-chart.component';
import LocationTreeCheckboxComponent from '../../components/location/location-tree-checkbox.component';
import SelectModelForNewModelDisplayComponent from '../../components/model/select-model-for-new-model-display.component';
import MultiSelectComponent from '../../components/multi-select/multi-select.component';
import paginationComponent from '../../components/pagination/pagination.component';
import SingleSelectComponent from '../../components/single-select/single-select.component';
import SelectSiteComponent from '../../components/site/select-site.component';
import { formats as FORMATS, codeMasterType } from '../../config/constants';
import { apiStatusCodes } from '../../config/global-variables';
import codeMasterModel from '../../models/common/code-master.model';
import GscmDivisionModel from '../../models/gscm-division/gscm-division.model';
import languageModel from '../../models/language.model';
import ProductCategoryModel from '../../models/product-category/product-category.model';
import ReportModel from '../../models/report/report-model.model';
import siteModel from '../../models/site/site.model';
import ViewBase from '../../views/view-base.view';

export default function NewModelDisplayFlooringView() {
  ViewBase.call(this);

  let buChannelTypeOptions = [];
  let buAccountOptions = [];
  let gscmDivisionOptions = [];
  let siteOptions = [];
  let productCategoryOptions = [];
  let statusOptions = [];
  let chartData;
  let tableData = [];
  let isLoadingChart = false;
  let isLoadingTable = false;
  let isDownloadingFiles = [false, false];
  let modelCodeFilterList = [];
  let previousRequestParams;
  let chartsContainerHeight = 'auto';

  const SELECT_ALL_OPTION = {
    code: '',
    get name() { return languageModel.getText("LT00000143", "All") }
  };

  const searchFields = {
    buAccount: { code: '' },
    buChannelType: { code: '' },
    gscmDivision: { code: '' },
    locationCodes: [],
    models: [],
    productCategories: [],
    sites: [],
    status: { code: '' },
    week: moment().format(FORMATS.WEEK_FORMAT),
  }

  const pagination = {
    pageIndex: 1,
    pageSize: 10,
    totalCount: 0
  }

  const requestParams = {
    get pageIndex() {
      return pagination.pageIndex;
    },

    get pageSize() {
      return pagination.pageSize;
    },

    get buAccount() {
      return searchFields.buAccount.code;
    },

    get buChannelType() {
      return searchFields.buChannelType.code;
    },

    get gscmDivision() {
      return searchFields.gscmDivision.code;
    },

    get locations() {
      return [...searchFields.locationCodes];
    },

    get modelCodes() {
      if (modelCodeFilterList?.length > 0) {
        return modelCodeFilterList.reduce((selectedCodes, filter) => {
          filter.selected
          if (filter.selected) {
            return [...selectedCodes, filter.modelCode];
          }
          return selectedCodes;
        }, []);
      }
      return searchFields.models.map(i => i.modelCode);
    },

    get productCategories() {
      return searchFields.productCategories.map(i => i.code);
    },

    get siteIds() {
      return searchFields.sites.map(i => i.code);
    },

    get statusCode() {
      return searchFields.status.code;
    },

    get week() {
      if (moment(searchFields.week, FORMATS.WEEK_FORMAT).isValid()) {
        return moment(searchFields.week, FORMATS.WEEK_FORMAT).format(FORMATS.API_WEEK_FORMAT);
      }

      return '';
    },
  }

  function resetSearchFields(skipWeek = false) {
    searchFields.buAccount = { code: '' };
    searchFields.buChannelType = { code: '' };
    searchFields.gscmDivision = { code: '' };
    searchFields.locationCodes.splice(0);
    searchFields.models.splice(0);
    searchFields.productCategories.splice(0);
    searchFields.sites.splice(0);
    searchFields.status = { code: '' };

    if (skipWeek !== true) {
      searchFields.week = moment().format(FORMATS.WEEK_FORMAT);
    }
  }

  function updateSearchFields(attr, value) {
    if (Array.isArray(searchFields[attr])) {
      searchFields[attr].splice(0, Infinity, ...value);
    } else {
      searchFields[attr] = value;
    }
  }

  function isFieldDisabled() {
    return requestParams.week === '' || !moment(requestParams.week, FORMATS.API_WEEK_FORMAT).isValid;
  }

  function onWeekChanged(e) {
    updateSearchFields(e.target.name, e.target.value);
    getSearchFilters();
    resetSearchFields(true);
  }

  let getBUAccountOptions = (week) => {
    if (!week) return;

    buAccountOptions.splice(0);

    return siteModel.getBUAccountsForModelDisplayFlooring(week)
      .then((result) => {
        if (result?.length > 0) {
          buAccountOptions.push(SELECT_ALL_OPTION);
          result.map(i => {
            buAccountOptions.push({ code: i.buAccount, name: i.buAccount })
          })
        }
      })
      .catch((error) => {
        buAccountOptions.splice(0);
        this.handleError(error);
      });
  }

  let getBUChannelTypeOptions = (week) => {
    if (!week) return;

    buChannelTypeOptions.splice(0);

    return siteModel.getBUChannelTypesForModelDisplayFlooring(week)
      .then((result) => {
        if (result?.length > 0) {
          buChannelTypeOptions.push(SELECT_ALL_OPTION);
          result.map(i => {
            buChannelTypeOptions.push({ code: i.buChannelType, name: i.buChannelType })
          })
        }
      })
      .catch((error) => {
        buChannelTypeOptions.splice(0);
        this.handleError(error);
      });
  }

  let getGscmDivisionOptions = (week) => {
    if (!week) return;

    gscmDivisionOptions.splice(0);

    GscmDivisionModel.getGscmDivisionsForNewModelDisplayFlooring(week)
      .then((result) => {
        if (result?.length > 0) {
          result.map(i => {
            gscmDivisionOptions.push({ code: i.divisionCode, name: i.divisionName })
          })
        }
      })
      .catch((error) => {
        gscmDivisionOptions.splice(0);
        this.handleError(error);
      })
  }

  let getProductCategoryOptions = (week) => {
    if (!week) return;

    productCategoryOptions.splice(0);

    ProductCategoryModel.getProductCategoryForNewModelDisplayFlooring(week)
      .then((result) => {
        result?.map(i => {
          productCategoryOptions.push({ code: i.productCategory, name: i.productCategory })
        })
      })
      .catch((error) => {
        productCategoryOptions.splice(0);
        this.handleError(error);
      })
  }

  let getSiteOptions = (week) => {
    if (!week) return;

    siteOptions.splice(0);

    return siteModel.getSitesForModelDisplayFlooring(week)
      .then((result) => {
        result?.map(i => {
          siteOptions.push({ code: i.siteId, name: i.siteName })
        })
      })
      .catch((error) => {
        siteOptions.splice(0);
        this.handleError(error);
      })
  }

  let getStatusOptions = () => {
    statusOptions.splice(0);
    codeMasterModel.getByCategoryV2({ category: codeMasterType.newModelDisplayStatus })
      .then((result) => {
        result?.map(i => {
          statusOptions.push({ code: i.code, name: this.getText(i.name, i.name) })
        })
      })
      .catch((error) => {
        statusOptions.splice(0);
        this.handleError(error);
      })
  }

  let getChartData = () => {
    isLoadingChart = true;

    return ReportModel.getStatisticsForNewModelDisplayFlooring(requestParams)
      .then((result) => {
        if (!modelCodeFilterList || modelCodeFilterList.length === 0) {
          modelCodeFilterList = result.models.map(m => ({ modelCode: m.modelCode, selected: true }));
        }

        chartData = {};

        if (result.summaryOfSeletedWeek) {

          chartData.statusByStoreNumber = [
            {
              key: 'Completed',
              value: result.summaryOfSeletedWeek.completedNumberOfStoresRatio,
            },
            {
              key: 'Incomplete',
              value: result.summaryOfSeletedWeek.incompleteNumberOfStoresRatio,
            }
          ]

          chartData.targetVsActualByQty = [
            {
              key: 'Actual',
              value: result.summaryOfSeletedWeek.completedQuantityRatio,
            },
            {
              key: 'Target',
              value: result.summaryOfSeletedWeek.incompleteQuantityRatio,
            }
          ]

        }

        chartData.statusByStoreNumberWeeklySummary = result.summaryOfWeekTrend.map(d => ({
          week: d.week,
          totalCompletedNumberOfStoresCount: d.totalCompletedNumberOfStoresCount,
          totalIncompleteNumberOfStoresCount: d.totalIncompleteNumberOfStoresCount
        }))

        chartData.targetVsActualByQtyWeeklySummary = result.summaryOfWeekTrend.map(d => ({
          week: d.week,
          totalTargetQuantity: d.totalTargetQuantity,
          totalActualQuantity: d.totalActualQuantity
        }))
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        isLoadingChart = false;
      })
  }

  let getTableData = () => {
    isLoadingTable = true;

    return ReportModel.getDetailsForNewModelDisplayFlooring(requestParams)
      .then((result) => {
        if (!result) {
          tableData = [];
          return;
        }

        pagination.totalCount = result.total;
        tableData = result.data;
      })
      .catch((error) => {
        tableData = [];
        this.handleError(error);
      })
      .finally(() => {
        isLoadingTable = false;
      })
  }

  let search = (e) => {
    // Form validation
    if (!this.validateForm(e)) {
      return false;
    }

    // Reset
    modelCodeFilterList = [];

    Promise.allSettled([getChartData(), getTableData()])
      .then(() => {
        previousRequestParams = structuredClone(requestParams);
      });

    return false;
  }

  let updateChart = () => {
    getChartData()
  }

  let clearFilters = (e) => {
    e.preventDefault();
    let form = document.querySelector('.needs-validation');
    form.classList.remove('was-validated');
    resetSearchFields();
  }

  let getSearchFilters = () => {
    this.showLoading();

    let optionPromises = [
      getBUAccountOptions(requestParams.week),
      getBUChannelTypeOptions(requestParams.week),
      getGscmDivisionOptions(requestParams.week),
      getProductCategoryOptions(requestParams.week),
      getSiteOptions(requestParams.week),
    ];

    if (statusOptions.length === 0) {
      optionPromises.push(getStatusOptions())
    }

    Promise.allSettled(optionPromises)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      })
  }

  let downloadExcel = (e) => {
    e.preventDefault();
    if (isDownloadingFiles[0]) {
      return false;
    }

    isDownloadingFiles[0] = true;
    ReportModel.exportNewModelDisplayFlooringDetailsToExcel(previousRequestParams)
      .catch((error) => {
        if (error.code === apiStatusCodes.noContent) {
          this.showErrorMessage(this.getText("LT00000317", "No results found"))
        } else {
          this.handleError(error);
        }
      })
      .finally(() => {
        isDownloadingFiles[0] = false;
      });

    return false;
  }

  let downloadPPT = (e) => {
    e.preventDefault();
    if (isDownloadingFiles[1] || !previousRequestParams?.buAccount) {
      return false;
    }

    isDownloadingFiles[1] = true;
    ReportModel.exportNewModelDisplayFlooringDetailsToPptx(previousRequestParams)
      .catch((error) => {
        if (error.code === apiStatusCodes.noContent) {
          this.showErrorMessage(this.getText("LT00000317", "No results found"))
        } else {
          this.handleError(error);
        }
      })
      .finally(() => {
        isDownloadingFiles[1] = false;
      });

    return false;
  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    pagination.pageIndex = pageIndex;
    pagination.pageSize = pageSize;
    getTableData();
  }

  let onPageChanged = (pageIndex) => {
    pagination.pageIndex = pageIndex;
    getTableData();
  }

  let handleWindowResize = (height) => {
    let theHeight;

    height ??= document.querySelector('.new-model-display-charts-container').offsetHeight;

    if (window.innerWidth < 992 || !height) {
      theHeight = 'auto';
    } else {
      theHeight = height + 'px';
    }

    if (chartsContainerHeight !== theHeight) {
      chartsContainerHeight = theHeight;
      m.redraw();
    }
  }

  let selectAllModelCodes = (e) => {
    e.preventDefault();
    modelCodeFilterList.map(model => {
      model.selected = true;
    });

    updateChart();
  }

  let deselectAllModelCodes = (e) => {
    e.preventDefault();
    modelCodeFilterList.map(model => {
      model.selected = false;
    })

    updateChart();
  }

  return {
    oninit: (vnode) => {
      getSearchFilters();
    },
    view: (vnode) => {
      return [
        // Search section
        m('.d-flex.flex-column.align-items-end.gap-2.mb-3',
          m('a.btn.btn-primary[role="button"][data-bs-toggle="collapse"][href="#search-section"][aria-controls="search-section"][aria-expanded="true"]',
            m('i.bi.bi-filter'),
            this.getText("LT00000232", "Filter"),
          ),
          m('#search-section.w-100.collapse.show',
            m('.card.mb-0',
              m('.card-body',
                m('form.row.g-4.align-items-end.needs-validation[novalidate]',
                  {
                    onsubmit: search
                  },
                  m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                    m('label.form-label.mandatory[for="week"]', this.getText("LT00000337", "Week")),
                    m('input#week.form-control[name="week"][type="week"][required]', {
                      value: searchFields.week,
                      onchange: onWeekChanged
                    }),
                    m('.invalid-tooltip', this.getText("LT00000729", "This field is required")),
                  ),
                  m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                    m('label.form-label.mandatory[for=gscmDivision]', this.getText("LT00000241", "GSCM Division")),
                    m(SingleSelectComponent, {
                      id: 'gscmDivision',
                      disabled: isFieldDisabled(),
                      items: gscmDivisionOptions,
                      selectedItem: searchFields.gscmDivision,
                      filterable: true,
                      allowEmpty: false,
                      required: true,
                      onSelect: (selectedItems) => {
                        updateSearchFields('gscmDivision', selectedItems);
                      }
                    }),
                    m('.invalid-tooltip', this.getText("LT00000729", "This field is required")),
                  ),
                  m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                    m('label.form-label[for=buChannelType]', this.getText("LT00000714", "BU Channel Type")),
                    m(SingleSelectComponent, {
                      id: 'buChannelType',
                      disabled: isFieldDisabled(),
                      items: buChannelTypeOptions,
                      selectedItem: searchFields.buChannelType,
                      filterable: true,
                      allowEmpty: false,
                      onSelect: (selectedItems) => {
                        updateSearchFields('buChannelType', selectedItems);
                      }
                    }),
                  ),
                  m('.col-xl-3.col-lg-4.col-sm-6.position-relative',
                    m('label.form-label[for=buAccount]', this.getText("LT00000715", "BU Account")),
                    m(SingleSelectComponent, {
                      id: 'buAccount',
                      disabled: isFieldDisabled(),
                      items: buAccountOptions,
                      selectedItem: searchFields.buAccount,
                      filterable: true,
                      allowEmpty: false,
                      onSelect: (selectedItems) => {
                        updateSearchFields('buAccount', selectedItems);
                      }
                    }),
                  ),
                  m('.col-xl-3.col-lg-4.col-sm-6',
                    m('label.form-label[for=productCategories]', this.getText("LT00000716", "Product Category")),
                    m(MultiSelectComponent, {
                      id: 'productCategories',
                      disabled: isFieldDisabled(),
                      items: productCategoryOptions,
                      selectedItems: searchFields.productCategories,
                      onSelect: (selectedItems) => {
                        updateSearchFields('productCategories', selectedItems);
                      }
                    }),
                  ),
                  m('.col-xl-3.col-lg-4.col-sm-6',
                    m('label.form-label[for=model]', this.getText("LT00000717", "Model")),
                    m(SelectModelForNewModelDisplayComponent, {
                      id: 'model',
                      disabled: isFieldDisabled(),
                      selectedItemList: searchFields.models,
                      week: requestParams.week,
                      onSelect: (selectedItems) => {
                        updateSearchFields('models', selectedItems);
                      }
                    }),
                  ),
                  m('.col-xl-3.col-lg-4.col-sm-6',
                    m('label.form-label[for=location]', this.getText("LT00000557", "Location")),
                    m(LocationTreeCheckboxComponent, {
                      id: 'location',
                      disabled: isFieldDisabled(),
                      selectedCodes: searchFields.locationCodes,
                      isLevel1Expanded: true,
                      onChange: (selectedItems) => {
                        updateSearchFields('locationCodes', selectedItems);
                      }
                    })
                  ),
                  m('.col-xl-3.col-lg-4.col-sm-6',
                    m('label.form-label[for=site]', this.getText("LT00000516", "Site(s)")),
                    m(SelectSiteComponent, {
                      id: 'site',
                      disabled: isFieldDisabled(),
                      filterable: true,
                      items: siteOptions,
                      selectedItemList: searchFields.sites,
                      searchable: false,
                      onChange: (selectedItems) => {
                        updateSearchFields('sites', selectedItems);
                      }
                    }),
                  ),
                  m('.col-xl-3.col-lg-4.col-sm-6',
                    m('label.form-label[for=status]', this.getText("LT00000015", "Status")),
                    m(SingleSelectComponent, {
                      id: 'status',
                      disabled: isFieldDisabled(),
                      items: statusOptions,
                      selectedItem: searchFields.status,
                      filterable: false,
                      onSelect: (selectedItems) => {
                        updateSearchFields('status', selectedItems);
                      }
                    }),
                  ),

                  // Search & clear buttons
                  m('.col-12.d-flex.justify-content-end.gap-2',
                    m('button.btn.btn-primary[type="submit"]', {
                    }, this.getText("LT00000001", "Search")),
                    m('button.btn.btn-white', {
                      onclick: clearFilters
                    }, this.getText("LT00000031", "Clear")),
                  ),
                ),
              )
            ),
          ),
        ),
        // Search section - end

        // Chart section
        m('.d-flex.flex-column.flex-lg-row.align-items-lg-start.gap-2.mb-3',
          m(Spinner, {
            active: isLoadingChart,
            background: true,
            fill: true,
            size: 'xl',
          }),
          m('.card.new-model-display-chart-filter-section.mb-0', {
            style: {
              height: chartsContainerHeight
            }
          },
            m('.card-body.h-100',
              m('.d-flex.justify-content-between',
                m('.fw-bold.mb-3',
                  this.getText("LT00000728", "Model Codes"),
                  m(Icon, { name: Icons.FILTER, class: 'ms-2' }),
                ),
                modelCodeFilterList?.length > 0 &&
                m('.d-flex.align-items-start.gap-1',
                  m('button.btn.btn-white.btn-sm', {
                    onclick: selectAllModelCodes,
                  }, this.getText("LT00000143", "All")),
                  m('button.btn.btn-white.btn-sm', {
                    onclick: deselectAllModelCodes,
                  }, this.getText("LT00000031", "Clear")),
                )
              ),
              m('.new-model-display-chart-filter-container.d-grid.d-lg-flex.flex-lg-column.gap-2.gap-lg-3',
                modelCodeFilterList?.map(model => [
                  m(Checkbox, {
                    checked: model.selected,
                    label: model.modelCode,
                    onchange: e => {
                      model.selected = !model.selected;
                      updateChart();
                    }
                  })
                ]),
                !(modelCodeFilterList?.length > 0) &&
                m(EmptyState, {
                  icon: Icons.FILTER,
                  content: this.getText("LT00000317", "No results found"),
                  fill: true,
                  style: 'color: #B5B5B5',
                })
              )
            )
          ),
          m('.flex-grow-1.d-grid.gap-2.new-model-display-charts-container', {
            oncreate: () => {
              window.addEventListener('resize', handleWindowResize);
            },
            onupdate: (vnode) => {
              handleWindowResize(vnode.dom.offsetHeight);
            }
          },
            m('.card',
              m('.card-body',
                m(NewModelDisplayPieChartComponent, {
                  title: this.getText("LT00000730", "Status by Number of Stores"),
                  colorSet: [
                    "#84E0BE", // Completed - Teal
                    "#F38068"  // Incomplete - Peach red
                  ],
                  data: chartData?.statusByStoreNumber
                })
              ),
            ),
            m('.card',
              m('.card-body',
                m(NewModelDisplayPieChartComponent, {
                  title: this.getText("LT00000731", "Target vs Actual by Quantity"),
                  colorSet: [
                    "#84E0BE", // Actual - Teal
                    "#D1EEFF"  // Target - Light blue
                  ],
                  data: chartData?.targetVsActualByQty
                })
              ),
            ),
            m('.card',
              m('.card-body',
                m(NewModelDisplayStackedBarChartComponent, {
                  title: `${this.getText("LT00000730", "Status by Number of Stores")} (${this.getText("LT00000732", "Weekly Trend")})`,
                  colorSet: [
                    "#84E0BE", // Completed - Teal
                    "#F38068"  // Incomplete - Peach red
                  ],
                  data: chartData?.statusByStoreNumberWeeklySummary
                })
              ),
            ),
            m('.card',
              m('.card-body',
                m(NewModelDisplayClusteredBarChartComponent, {
                  title: `${this.getText("LT00000731", "Target vs Actual by Quantity")} (${this.getText("LT00000732", "Weekly Trend")})`,
                  colorSet: [
                    "#D1EEFF", // Target - Light blue
                    "#84E0BE"  // Actual - Teal
                  ],
                  data: chartData?.targetVsActualByQtyWeeklySummary
                })
              ),
            ),
          )
        ),
        // Chart section - end

        // Table section
        m('.card',
          m('.card-body',
            m(Spinner, {
              active: isLoadingTable,
              background: true,
              fill: true,
              size: 'xl',
            }),
            m('.d-flex.justify-content-end.mb-2',
              m('.input-group.w-auto',
                m('button.btn.btn-primary.dropdown-toggle.dropdown-toggle-split[type=button][data-bs-toggle=dropdown][arie-expanded=false]',
                  {
                    disabled: !previousRequestParams,
                  },
                  isDownloadingFiles.includes(true)
                    ? m('span.spinner-border.spinner-border-sm.me-2[role=status][aria-hidden=true]')
                    : m('i.bi.bi-file-earmark-arrow-down-fill'),
                  this.getText("LT00000492", "Download")
                ),
                m('ul.dropdown-menu',
                  m('li',
                    m('a.dropdown-item[href="javascript:void(0);"]', {
                      class: isDownloadingFiles[0] ? 'disabled' : '',
                      onclick: downloadExcel
                    },
                      isDownloadingFiles[0] &&
                      m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                      this.getText("LT00000493", "Excel")
                    )
                  ),
                  m('li',
                    m('a.dropdown-item[href="javascript:void(0);"]', {
                      class: isDownloadingFiles[1] || !previousRequestParams?.buAccount ? 'disabled' : '',
                      onclick: downloadPPT
                    },
                      isDownloadingFiles[1] &&
                      m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                      this.getText("LT00000494", "PPT")
                    )
                  ),
                ),
              ),
            ),
            m('.row',
              m('.col-12.p-0',
                m('.table-responsive',
                  m('table.table', [
                    m('thead.thead-bggrey',
                      m('tr.align-middle', [
                        m('th[scope="col"]', this.getText("LT00000721", "No.")),
                        m('th[scope="col"]', this.getText("LT00000725", "GSCM Division Code")),
                        m('th[scope="col"]', this.getText("LT00000714", "BU Channel type")),
                        m('th[scope="col"]', this.getText("LT00000715", "BU Account")),
                        m('th[scope="col"]', this.getText("LT00000072", "Site Group")),
                        m('th[scope="col"]', this.getText("LT00000722", "Region")),
                        m('th[scope="col"]', this.getText("LT00000723", "Site Code")),
                        m('th[scope="col"]', this.getText("LT00000144", "Site Name")),
                        m('th[scope="col"]', this.getText("LT00000049", "User ID")),
                        m('th[scope="col"]', this.getText("LT00000050", "User Name")),
                        m('th[scope="col"]', this.getText("LT00000060", "User Role")),
                        m('th[scope="col"]', this.getText("LT00000724", "Submission Date")),
                        m('th[scope="col"]', this.getText("LT00000726", "GSCM Division Name")),
                        m('th[scope="col"]', this.getText("LT00000716", "Product Category")),
                        m('th[scope="col"]', this.getText("LT00000717", "Model")),
                        m('th[scope="col"]', this.getText("LT00000337", "Week")),
                        m('th[scope="col"]', this.getText("LT00000736", "Type Of Actual Display")),
                        m('th[scope="col"]', this.getText("LT00000735", "Target Qty")),
                        m('th[scope="col"]', this.getText("LT00000733", "Total Display Qty")),
                        m('th[scope="col"]', this.getText("LT00000727", "Normal Display Qty")),
                        m('th[scope="col"]', this.getText("LT00000734", "Special Display Qty")),
                        m('th[scope="col"]', this.getText("LT00000333", "Achievement") + ' (%)'),
                      ])
                    ),
                    m('tbody',
                      (tableData.length == 0) &&
                      m('tr.align-middle',
                        m('td[colspan=22]', this.getText("EM00000141", "No records found."))
                      ),
                      tableData.length > 0 &&
                      tableData.map((col, index) => [
                        m('tr.align-middle',
                          m('td', col.rowId),
                          m('td', col.gscmDivision),
                          m('td', col.buChannelType),
                          m('td', col.buAccount),
                          m('td', col.siteGroup),
                          m('td', col.region),
                          m('td', col.siteId),
                          m('td', col.siteName),
                          m('td', col.userId),
                          m('td', col.userName),
                          m('td', col.userRole),
                          m('td', col.dateSubmitted),
                          m('td', col.prod),
                          m('td', col.segment),
                          m('td', col.modelCode),
                          m('td', col.week),
                          m('td', col.typeOfActualDisplay),
                          m('td', col.targetQuantity ?? '-'),
                          m('td', col.totalDisplayQuantity ?? '-'),
                          m('td', col.normalDisplayQuantity ?? '-'),
                          m('td', col.specialDisplayQuantity ?? '-'),
                          m('td', col.achievement),
                        )
                      ])
                    )
                  ])
                ),
                tableData.length > 0 &&
                m(".px-3",
                  m(paginationComponent, {
                    currentPage: pagination.pageIndex,
                    pageSize: pagination.pageSize,
                    totalItems: pagination.totalCount,
                    onPageChanged: onPageChanged,
                    onPageSizeChanged: onPageSizeChanged
                  })
                )
              )
            )
          )
        ),
        // Table section - end

        this.getBaseViews()
      ]
    }
  }
}
